import { AssetLocale } from '../../AssetService/useLocale';

function trimSlashes(s: string) {
  return s.replace(/^\/+|\/+$/g, '');
}

function getBaseURL() {
  return trimSlashes(import.meta.env.VITE_ASSETS_BASE);
}

export function buildEulaUrl({ country, lang }: AssetLocale): string {
  const base = getBaseURL();
  return `/${base}/${country}/${lang}/eula/master.model.json`;
}
